import { IBaseIconProps } from "./IBaseIconProps";

export const TwoCheckmarksSeenIcon = ({
  color = "#000",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14L5.23309 16.4248C5.66178 16.7463 6.26772 16.6728 6.60705 16.2581L15 6"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.191 15.3932L11.9153 16.7726C12.5572 17.2861 13.4928 17.1873 14.0133 16.5511L22.387 6.31663C22.5618 6.10291 22.5303 5.7879 22.3166 5.61304C22.1029 5.43817 21.7879 5.46967 21.613 5.6834L13.2393 15.9179C13.0658 16.13 12.754 16.1629 12.54 15.9917L10.8243 14.6192L10.191 15.3932Z"
        fill={color}
      />
    </svg>
  );
};
